import React from "react";
import {Branding, FooterFontSize, FooterStyle, Link, SpanImg, TitleContainer, TosContainer} from "./Footer.css";
import appleStore from '/assets/apple-store.svg?url';
import playStore from '/assets/play-store.svg?url';
import {useNavigate} from "react-router";
import {HideOnMobile} from "../../global.css";

function Footer() {
    const navigate = useNavigate()
    return (
        <div className={FooterStyle}>
            <div className={TitleContainer}>
                <div className={`${FooterFontSize}`}>
                    <span>Pour un usage optimal sur smartphone, l’application est disponible sur</span>
                    <a className={Link} target={"blank"} href={"https://apps.apple.com/fr/app/webline/id6498628900"}> App Store <img className={SpanImg} src={appleStore} alt={"Apple Logo"}/></a>
                    <span> et</span>
                    <a className={Link} target={"blank"} href={"https://play.google.com/store/apps/details?id=com.montepaschibanque.webline"}> Google Play <img className={SpanImg} src={playStore} alt={"Google Logo"}/></a>
                </div>
            </div>
            <div className={`${TosContainer} ${FooterFontSize}`}>
                <span>Tous droits réservés</span>
                <span>Copyright 2024</span>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.montepaschi-banque.fr"}>Monte Paschi Banque</a>
                <span className={HideOnMobile}>-</span>
                <button className={Link} onClick={() => navigate("/home/kpi")}>KPI</button>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.montepaschi-banque.fr/fr/numeros-urgence"}>Numéro d'urgence</a>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://ewebline.montepaschi-banque.fr/portail/edito/documents/Politique_cookies.pdf"}>Politiques Cookies</a>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.montepaschi-banque.fr/fr/mentions-legales"}>Mentions légales</a>
                <span className={HideOnMobile}>-</span>
                <a target={"blank"} href={"https://www.mps.it/"} className={Branding}>GRUPPOMONTEPASCHI</a>
            </div>
        </div>
    );
}

export default Footer;